<script lang="ts">
    import { onMount } from 'svelte'
    import { derived as sderived, writable } from 'svelte/store'

    import { toASCII, toUnicode } from 'punycode-esm'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'
    import { sgoto, spath, sreplace } from 'hydria/svelte_helpers'

    import { Breadcrumb } from 'breadcrumb'

    interface Props {
        route: any
    }

    let { route }: Props = $props()

    const ready = writable(false)
    let working = $state(false)

    let userId = $derived(route.result.path.params?.userId)
    let name = $derived(route.result.path.params?.name ? toUnicode(route.result.path.params?.name) : '')

    let submitReady = $derived($ready && name.match(/[^.].*\.[^.]+/))

    fetchOwnerName()

    let ownerName: string
    async function fetchOwnerName() {
        try {
            const r = await simpleFetch('GET', `/json/wdom-user/1/${userId}/name`)
            ownerName = r.data.name ? r.data.name : '?'
            ready.set(true)
        } catch (e) {
            notify({
                type: 'warning',
                title: 'Nouvelle zone',
                text: 'L’utilisateur n’existe pas.',
            })
            sreplace(`/zones?owner=${userId}`)
        }
    }

    async function submit() {
        working = true
        let aname = toASCII(name)
        try {
            const r = await simpleFetch('PUT', `/json/zone/1/${aname}/${userId}`)
            notify({
                type: 'success',
                title: 'Nouvelle zone',
                text: 'Zone créée.',
            })
            sgoto(`/zone/${r.data.item.idna}`)
        } catch (e: any) {
            console.error('Failed to create zone:', e)
            working = false
            notify({
                type: 'danger',
                title: 'Nouvelle zone',
                text: 'La création de la zone n’a pas fonctionné' + (e && e.data && e.data.error ? ` : ${e.data.error} (${e.data.ecode})` : '.'),
            })
        }
    }

    let element: HTMLInputElement

    onMount(() => {
        if (element) element.focus()
    })

    const crumbs = sderived(ready, ($ready) => [
        { txt: $_('Zones'), url: spath('/zones') },
        { txt: $_('New') },
        {
            txt: ownerName != null ? ownerName : userId,
        },
    ])
</script>

<style>
    .col-content {
        margin-right: 280px;
    }
    .col-save {
        position: absolute;
        /* Fix le modal à l’intérieur de .col-save, moins de trouble que de portaller */
        z-index: 1;
        top: 0;
        right: 0;
        width: 250px;

        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        height: calc(100vh - 80px - 2rem - 65px);
    }

    @media (max-width: 767px) {
        .col-content {
            margin-right: 0;
        }
        .col-save {
            position: relative;
            width: 100%;
            top: 0;
        }
    }
</style>

<Breadcrumb {crumbs} />

<div style="position: relative">
    <form
        onsubmit={(e) => {
            e.preventDefault()
            submit()
        }}
    >
        <div class="col-content">
            <div class="card">
                <div class="card-title text-primary">{$_('New zone')}</div>
                <div class="card-body">
                    <div class="row">
                        <label class="col-sm-3 col-lg-4 col-form-label" for="newZoneName">Zone name</label>
                        <div class="col-sm-9 col-lg-8">
                            <input type="text" class="form-control" id="newZoneName" bind:value={name} bind:this={element} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-save">
            <div class="card card-cart">
                <div class="card-title text-primary">{$_('Zone')}</div>
                <div class="card-body d-grid">
                    <button type="submit" class="btn save btn-primary" disabled={!submitReady}>
                        {#if working}
                            <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                            Un moment…
                        {:else}
                            {$_('Create')}
                        {/if}
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
